import { render, staticRenderFns } from "./LinkAttachment.vue?vue&type=template&id=5f0ebd64"
import script from "./LinkAttachment.vue?vue&type=script&lang=js"
export * from "./LinkAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports